import { render } from "./FallbackModelViewer.vue?vue&type=template&id=3815061f&scoped=true"
import script from "./FallbackModelViewer.vue?vue&type=script&lang=js"
export * from "./FallbackModelViewer.vue?vue&type=script&lang=js"

import "./FallbackModelViewer.vue?vue&type=style&index=0&id=3815061f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3815061f"]])

export default __exports__